import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function SolutionSection() {
  const solutions = ['Un sistema paso a paso que te guía desde la masa hasta la decoración final', 'El secreto de los 38g exactos por bollito para que cada capa salga siempre fina y pareja', 'La fórmula exacta del dulce de leche con la textura ideal (ni líquido ni apelmazado)', 'El merengue italiano brillante y firme que resiste horas sin caerse ni derretirse', 'Técnica de estirado transparente que solo conocen los pasteleros profesionales', 'Tiempos y temperaturas exactas para cada horno (eléctrico, a gas, de convección — todos funcionan)'];
  return <section className="bg-brand-cream py-12 md:py-16" data-id="element-362">
      <div className="max-w-5xl mx-auto px-4" data-id="element-363">
        <div className="text-center mb-16" data-id="element-364">
          <FadeIn data-id="element-365">
            <h2 className="text-4xl md:text-5xl font-bold text-brand-brown mb-4" data-id="element-366">
              La Solución Única
            </h2>
            <p className="text-xl text-brand-brown/70 font-serif italic" data-id="element-367">
              Aquí es donde entra el Método Milhojas Perfecta, creado por Stella
              Pereira.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-368">
          {solutions.map((solution, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-369">
              <div className="bg-white p-6 rounded-xl shadow-warm border border-brand-gold/10 h-full flex items-start" data-id="element-370">
                <span className="text-2xl mr-4 flex-shrink-0" data-id="element-371">✅</span>
                <p className="text-brand-brown text-lg leading-relaxed" data-id="element-372">
                  {solution}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-373">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-374">
            <p className="text-2xl md:text-3xl text-brand-gold-dark font-serif font-bold leading-relaxed" data-id="element-375">
              "Con este método, cualquier persona — aunque nunca haya horneado
              una milhojas — puede lograr un resultado digno de pastelería
              profesional."
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.5} className="text-center" data-id="element-376">
          <CTAButton isPayment data-id="element-377">
            🛒 Sí, quiero aprender el método ahora
          </CTAButton>
        </FadeIn>
      </div>
    </section>;
}